import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { LoginPageComponent } from 'pages/login-page/login-page.component';
import { ClassifierPageComponent } from 'pages/classifier-page/classifier-page.component';
import { StructuralUnitPageComponent } from 'pages/structural-unit-page/structural-unit-page.component';
import { ReadingRoomListPageComponent } from 'pages/reading-room-pages/reading-room-list-page/reading-room-list-page.component';
import { ViewReadingRoomPageComponent } from 'pages/reading-room-pages/view-reading-room-page/view-reading-room-page.component';
import { ReadingRoomFormPageComponent } from 'pages/reading-room-pages/reading-room-form-page/reading-room-form-page.component';
import { RolePageComponent } from 'pages/role-page/role-page.component';
import { RoleFormPageComponent } from 'pages/role-form-page/role-form-page.component';
import { EditBackofficeUserPageComponent } from 'pages/backoffice-user-pages/edit-backoffice-user-page/edit-backoffice-user-page.component';
import { BackofficeUserListPageComponent } from 'pages/backoffice-user-pages/backoffice-user-list-page/backoffice-user-list-page.component';
import { ClientListPageComponent } from 'pages/client-pages/client-list-page/client-list-page.component';
import { ViewClientPageComponent } from 'pages/client-pages/view-client-page/view-client-page.component';
import { EditClientPageComponent } from 'pages/client-pages/edit-client-page/edit-client-page.component';
import { AddClientPageComponent } from 'pages/client-pages/add-client-page/add-client-page.component';
import { AddOrganizationPageComponent } from 'pages/client-pages/add-organization-page/add-organization-page.component';
import { ViewOrganizationPageComponent } from 'pages/client-pages/view-organization-page/view-organization-page.component';
import { ResearchTopicFormPageComponent } from 'pages/research-topic-form-page/research-topic-form-page.component';
import { WorkspacePageComponent } from 'pages/workspace-page/workspace-page.component';
import { VisitRoomServicePageComponent } from 'pages/visit-room-service-page/visit-room-service-page.component';
import { CreateServiceApplicationPageComponent } from 'pages/create-service-application-page/create-service-application-page.component';
import { ClaimsGuard } from './guards/claims.guard';
import { UnsavedChangesGuard } from './guards/unsaved-changes.guard';
import { ServiceProcessingPageComponent } from 'pages/service-processing-page/service-processing-page.component';
import { TooltipListPageComponent } from 'pages/tooltips/tooltip-list-page/tooltip-list-page.component';
import { EditTooltipPageComponent } from 'pages/tooltips/edit-tooltip-page/edit-tooltip-page.component';
import { AuditListPageComponent } from 'pages/audit-list-page/audit-list-page.component';
import { InfoRequestServicePageComponent } from 'pages/info-request-service-page/info-request-service-page.component';
import { CreateInfoRequestPageComponent } from 'pages/create-info-request-page/create-info-request-page.component';
import { InfoRequestWorkspacePageComponent } from 'pages/info-request-workspace-page/info-request-workspace-page.component';
import { ViewInfoRequestPageComponent } from 'pages/view-info-request-page/view-info-request-page.component';
import { NotificationsPageComponent } from 'pages/notifications-page/notifications-page.component';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginPageComponent
  },
  {
    path: '',
    redirectTo: 'pazinojumi',
    pathMatch: 'full'
  },
  {
    path: 'pazinojumi',
    component: NotificationsPageComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'lasitavas-apmeklejums',
    component: WorkspacePageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    data: {
      policyType: ['ServiceSubmission']
    }
  },
  {
    path: 'klasifikatori',
    component: ClassifierPageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    data: {
      policyType: ['Classifier']
    }
  },
  {
    path: 'strukturvienibas',
    component: StructuralUnitPageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    data: {
      policyType: ['StructuralUnit']
    }
  },
  {
    path: 'lasitavas',
    component: ReadingRoomListPageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    data: {
      policyType: ['ReadingRoom']
    }
  },
  {
    path: 'lasitava/:id',
    component: ViewReadingRoomPageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    data: {
      policyType: ['ReadingRoom']
    }
  },
  {
    path: 'lasitavas/pievienot',
    component: ReadingRoomFormPageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    data: {
      policyType: ['ReadingRoom']
    }
  },
  {
    path: 'lasitavas/:id/rediget',
    component: ReadingRoomFormPageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    data: {
      policyType: ['ReadingRoom']
    }
  },
  {
    path: 'lomas',
    component: RolePageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    data: {
      policyType: ['Role']
    }
  },
  {
    path: 'lomas/:id/rediget',
    component: RoleFormPageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    data: {
      policyType: ['Role']
    }
  },
  {
    path: 'lomas/:id',
    component: RoleFormPageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    data: {
      policyType: ['Role']
    }
  },
  {
    path: 'lietotaji',
    component: BackofficeUserListPageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    data: {
      policyType: ['User']
    }
  },
  {
    path: 'lietotajs/:id/rediget',
    component: EditBackofficeUserPageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    data: {
      policyType: ['User']
    }
  },
  {
    path: 'klienti/pievienot',
    component: AddClientPageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    data: {
      policyType: ['Client']
    }
  },
  {
    path: 'klienti/pievienot-juridisku-personu',
    component: AddOrganizationPageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    data: {
      policyType: ['Client']
    }
  },
  {
    path: 'klienti',
    component: ClientListPageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    data: {
      policyType: ['Client']
    }
  },
  {
    path: 'klienti/juridiskas-personas',
    component: ClientListPageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    data: {
      policyType: ['Client'],
      tab: 'organization'
    }
  },
  {
    path: 'juridiska-persona/:id',
    component: ViewOrganizationPageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    data: {
      policyType: ['Client']
    }
  },
  {
    path: 'klients/:id',
    component: ViewClientPageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    data: {
      policyType: ['Client']
    }
  },
  {
    path: 'klients/:id/rediget',
    component: EditClientPageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    data: {
      policyType: ['Client']
    }
  },
  {
    path: 'petijuma-tema/pievienot',
    component: ResearchTopicFormPageComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'petijuma-tema/rediget/:id/:clientId',
    component: ResearchTopicFormPageComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'petijuma-tema/pievienot/:clientId',
    component: ResearchTopicFormPageComponent,
    canActivate: [AuthGuard]
  },
  {
    path: ':clientId/pakalpojumi/lasitavas-apmeklejums',
    component: VisitRoomServicePageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    canDeactivate: [UnsavedChangesGuard],
    data: {
      policyType: ['ServiceSubmission']
    }
  },
  {
    path: 'pakalpojumi/lasitavas-apmeklejums/:submissionId',
    component: VisitRoomServicePageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    canDeactivate: [UnsavedChangesGuard],
    data: {
      policyType: ['ServiceSubmission']
    }
  },
  {
    path: ':clientId/pakalpojumi/lasitavas-apmeklejums/:id',
    component: VisitRoomServicePageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    canDeactivate: [UnsavedChangesGuard],
    data: {
      policyType: ['ServiceSubmission']
    }
  },
  {
    path: ':clientId/pakalpojumi/informacijas-pieprasijums',
    component: InfoRequestServicePageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    canDeactivate: [UnsavedChangesGuard],
    data: {
      policyType: ['InformationRequest']
    }
  },
  {
    path: 'pakalpojumi/informacijas-pieprasijums/:id',
    component: InfoRequestServicePageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    canDeactivate: [UnsavedChangesGuard],
    data: {
      policyType: ['InformationRequest']
    }
  },
  {
    path: 'pieprasijums/:id',
    redirectTo: 'informacijas-pieprasijums/:id',
    pathMatch: 'full'
  },
  {
    path: 'informacijas-pieprasijums',
    component: InfoRequestWorkspacePageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    data: {
      policyType: ['InformationRequest']
    }
  },
  {
    path: 'informacijas-pieprasijums/pievienot',
    component: CreateInfoRequestPageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    data: {
      policyType: ['InformationRequest']
    }
  },
  {
    path: 'informacijas-pieprasijums/:id',
    component: ViewInfoRequestPageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    data: {
      policyType: ['InformationRequest']
    }
  },
  {
    path: 'jauns-pakalpojuma-pieteikums',
    component: CreateServiceApplicationPageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    data: {
      policyType: ['ServiceSubmission']
    }
  },
  {
    path: 'pieteikums/:id',
    component: ServiceProcessingPageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    data: {
      policyType: ['ServiceSubmission']
    }
  },
  {
    path: 'uznirstosie-portala-padomi',
    component: TooltipListPageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    data: {
      isAdminOnly: true
    }
  },
  {
    path: 'uznirstosie-portala-padomi/rediget/:id',
    component: EditTooltipPageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    data: {
      isAdminOnly: true
    }
  },
  {
    path: 'audits',
    component: AuditListPageComponent,
    canActivate: [AuthGuard, ClaimsGuard],
    data: {
      isAdminOnly: true
    }
  }
];
